import { useTranslation } from "react-i18next";
import { MessageCircle, ReportBadge } from "@dreamhub/designsystem/icons";
import { Button } from "@/components/ui/button";
import IconContainer from "@/components/ui/icon-container";
import Text from "@/components/ui/text";
import { useChatTabs } from "@/components/global/Chat/components/chat/ChatTabsContext";
import { TRANSLATION_KEY } from "@/components/global/Chat/components/dreamerReports/consts";

const EMPTY_TRANSLATION_KEY = `${TRANSLATION_KEY}.emptyState`;

interface ReportsEmptyStateProps {
  /** The Scheduled filter, which names what is missing: a schedule. */
  scheduledOnly?: boolean;
  /** Closes the surface this sits in before switching to chat, when that is not the drawer. */
  onLeave?: () => void;
}

/** The Reports tab with nothing to list, pointing back to chat. */
export const ReportsEmptyState: React.FC<ReportsEmptyStateProps> = ({
  scheduledOnly = false,
  onLeave
}) => {
  const { t } = useTranslation();
  const { showTab } = useChatTabs();

  return (
    <div
      className="flex flex-1 flex-col items-center justify-center gap-4 px-6 text-center"
      data-test="reports-empty-state"
    >
      <ReportBadge />
      <div className="flex max-w-[320px] flex-col gap-1">
        <Text variant="body">
          {t(
            `${EMPTY_TRANSLATION_KEY}.${scheduledOnly ? "scheduledTitle" : "title"}`
          )}
        </Text>
        <Text variant="bodySecondary">
          {t(
            `${EMPTY_TRANSLATION_KEY}.${scheduledOnly ? "scheduledDescription" : "description"}`
          )}
        </Text>
      </div>
      <Button
        variant="secondary"
        onClick={() => {
          onLeave?.();
          showTab("chat");
        }}
        data-test="reports-back-to-chat"
      >
        <IconContainer size="sm">
          <MessageCircle />
        </IconContainer>
        {t(`${EMPTY_TRANSLATION_KEY}.backToChat`)}
      </Button>
    </div>
  );
};
